export default {
    orbLeftTranslate: 1.5,
    orbLeftTranslateDelay: 0.5,
    maxParticleAssembleTime: 3,
    welcomeTextAnimationTime: 1,
    welcomeButtonAnimationDelay: 0.8,
    welcomeButtonAnimationTime: 1.5
}